<template>
  <div class="offer-info-block">
    <div class="offer-info-block__info">
      <Icon class="warning-icon" type="error-red" size="20" color="warning" />
      <div class="text-sm">
        <slot />
      </div>
    </div>
    <button @click="$emit('close')">
      <CloseIcon class="close-button__icon" />
    </button>
  </div>
</template>

<script>
  import CloseIcon from '@/assets/icons/x.svg';
  import Icon from '@/components/ui/Icon';

  export default {
    name: 'AlertMessage',
    components: {
      Icon,
      CloseIcon,
    },
  };
</script>

<style lang="scss" scoped>
  @import 'src/styles/colors';

  .offer-info-block {
    background: #fff3d8;
    box-shadow: inset 0px -1px 0px #e8ebf0;

    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 14px;

    &__info {
      display: flex;

      ::v-deep a {
        color: $primary600;
        text-decoration: none;
      }
    }

    .warning-icon {
      margin-right: 10px;
      min-width: 20px;
      height: auto;
    }
  }
</style>
